/** Alpha is the top felt's coverage; transparent engraving reaches the bottom sheet. */
export interface LayeredRelief { size: number; coverage: Float32Array }
export async function loadLayeredRelief(url: string): Promise<LayeredRelief | undefined> {
  if (!url || typeof document === 'undefined') return
  try {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    await new Promise<void>((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Relief image timeout')), 8000)
      image.onload = () => { clearTimeout(timer); resolve() }
      image.onerror = () => { clearTimeout(timer); reject(new Error('Relief image unavailable')) }
      image.src = url
    })
    const canvas = document.createElement('canvas')
    canvas.width = image.naturalWidth; canvas.height = image.naturalHeight
    const ctx = canvas.getContext('2d')!
    ctx.drawImage(image, 0, 0)
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data
    const size = 193, coverage = new Float32Array(size * size)
    // Minimum alpha in each sample footprint retains narrow grooves at export resolution.
    for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) {
      const cx = x * (canvas.width - 1) / (size - 1), cy = y * (canvas.height - 1) / (size - 1)
      const radius = Math.max(1, Math.floor(canvas.width / (size - 1) / 2))
      let alpha = 255
      for (let py = Math.max(0, Math.floor(cy) - radius); py <= Math.min(canvas.height - 1, Math.ceil(cy) + radius); py++)
        for (let px = Math.max(0, Math.floor(cx) - radius); px <= Math.min(canvas.width - 1, Math.ceil(cx) + radius); px++)
          alpha = Math.min(alpha, pixels[(py * canvas.width + px) * 4 + 3])
      coverage[y * size + x] = alpha / 255
    }
    return { size, coverage }
  } catch { return undefined }
}
